import {Component, Input, OnInit} from '@angular/core';
import {IconService} from '../../../../shared/services/icon/icon.service';

@Component({
  selector: 'app-dashboard-edas-detail',
  templateUrl: './dashboard-edas-detail.component.html',
  styleUrls: ['./dashboard-edas-detail.component.css']
})
export class DashboardEdasDetailComponent implements OnInit {

  @Input('dashboardElement') dashboardElement: any = {};

  constructor(public iconService: IconService) {
  }

  ngOnInit(): void {
  }

  getClassByNote(): string {
    let note = parseInt(this.dashboardElement.note);

    let classNote = 'green';
    if (note === 0) {
      classNote = 'red';
    }
    if (note === 1) {
      classNote = 'orange';
    }
    return classNote;
  }

  getIconStatus() {
    let note = parseInt(this.dashboardElement.note);
    let icon = this.iconService.faSmile;
    if (note === 0) {
      icon = this.iconService.faSadTear;
    }
    if (note === 1) {
      icon = this.iconService.faFrown;
    }
    return icon;
  }

}
